import { useState } from "react";
import MainLayout from "../../layouts/MainLayout";
import mainStyle from "../../style/Main.module.css";
import { GoFilter } from "react-icons/go";
import SearchComponent from "../../components/ui/input/Search/Search";
import Button from "../../components/ui/buttons/Button";
import { useNavigate } from "react-router-dom";
import formatDate from "../../components/ui/dateFormat";
import Select from "react-select";
import PaginationComponent from "../../components/ui/Pagination/PaginationComponent";
import NoDataFound from "../../components/ui/NoDataFound/NoDataFound";
import PageLoader from "../../components/ui/Loader/PageLoader";
import { statusOptions } from "../../config/selectOptions";
import { useGroupList, useUpdateStatusGroup } from "../../hooks/useGroup";
import { useCompanyFilter } from "../../hooks/UseFilter";
import StatusBadge from "../../components/ui/StatusBadge";
import GroupPeopleView from "./GroupPeopleView";
import { groupAdd, groupEdit, groupStatus } from "../../routes/AccessCondition";
import ViewGroupPopUp from "../chat/PopUp/ViewGroupPopUp";
import { FiEdit } from "react-icons/fi";
import FallbackAvatar from "../../components/ui/FallbackAvatar/FallbackAvatar";

const ViewGroup = () => {
  const perPage = 10;
  const navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_API_URL;
  const [showFilter, setShowFilter] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [isAllChecked, setIsAllChecked] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState([]);
  const [company, setCompany] = useState("");
  const [search, setSearch] = useState("");
  const [datas, setDatas] = useState("");
  const [status, setStatus] = useState("");
  const [openPeopleList, setopenPeopleList] = useState(false);
  const [showGroupPopup, setShowGroupPopup] = useState(false);
  const [groupId, setgroupId] = useState();
  const [imageErrorsMG, setImageErrorsMG] = useState({});
  const [imageErrorsUR, setImageErrorsUR] = useState({});
  const addAccess = groupAdd();
  const editAccess = groupEdit();
  const statusAccess = groupStatus();

  const companyFilter = useCompanyFilter();
  const {
    groupData: ViewGroupData,
    totalCount: totalGroupCount,
    loading: isLoading,
    refresh: refreshGroupList, // Make sure your useEmployeeList hook provides this
  } = useGroupList(company, search, currentPage, perPage, status);
  const toggleFilter = () => setShowFilter((prev) => !prev);
  const { updateGroupStatus, loading: updateLoading } = useUpdateStatusGroup();

  const handleAllCheckboxChange = () => {
    if (isAllChecked) {
      setSelectedGroup([]);
    } else {
      setSelectedGroup(ViewGroupData.map((employee) => employee.id));
    }
    setIsAllChecked(!isAllChecked);
  };

  const handleCheckboxChange = (id) => {
    setSelectedGroup((prevState) => {
      let newSelected;
      if (prevState.includes(id)) {
        newSelected = prevState.filter((empId) => empId !== id);
      } else {
        newSelected = [...prevState, id];
      }

      //ViewGroupData
      setIsAllChecked(newSelected.length === ViewGroupData.length);

      return newSelected;
    });
  };
  const openPeopleListPage = (emp) => {
    const payload = {
      Field: "Staff List",
      group_name: emp.group_name,
      peopleList: emp.group_users_list,
    };
    setDatas(payload);
    setopenPeopleList(true); // Open the modal
  };

  const openAdminListPage = (emp) => {
    const payload = {
      Field: "Admin List",
      group_name: emp.group_name,
      peopleList: emp.get_group_admin_details,
    };

    setDatas(payload);
    setopenPeopleList(true); // Open the modal
  };

  const closePeoplePopup = () => {
    setopenPeopleList(false);
    // refreshEmployeeList(); // Refresh the list after editing
  };

  const currentPageNo = (selectedPage) => {
    setCurrentPage(selectedPage.selected + 1);
  };

  const handleSearch = (term) => {
    if (term !== search) {
      setSearch(term);
      setCurrentPage(1);
    }
  };

  const handleCompanyFilter = (option) => {
    if (option?.value !== company) {
      setCompany(option.value);
      setCurrentPage(1);
    }
  };

  const handleStatusUpdate = async (statusType) => {
    try {
      await updateGroupStatus(selectedGroup, statusType);
      refreshGroupList(); // reload list
      setSelectedGroup([]); // clear selection
      setIsAllChecked(false);
    } catch (error) {
      console.error("Error updating status:", error.message);
    }
  };

  const handleFilterChange = (selectedOption) => {
    const newStatus = selectedOption ? selectedOption.value : "";
    if (newStatus !== status) {
      setStatus(newStatus);
      setCurrentPage(1);
    }
  };

  const addUserPage = () => {
    navigate("/group/add");
  };

  const openEditPage = (id) => {
    setgroupId(id);
    setShowGroupPopup(true);
  };

  const handleUpdated = () => {
    refreshGroupList();
  };
  return (
    <>
      <MainLayout>
        <div className={mainStyle.mainPageHeader}>
          {selectedGroup.length === 0 ? (
            <>
              <div>
                <p>Group List</p>
              </div>
              <div className={mainStyle.mainPageButtons}>
                <SearchComponent onSearch={handleSearch} />
                {addAccess && (
                  <Button onClick={() => navigate("/group/add")}>
                    Add Group
                  </Button>
                )}

                <button
                  className={mainStyle.FilterButton}
                  onClick={toggleFilter}
                >
                  <GoFilter /> Filter
                </button>
              </div>
            </>
          ) : (
            <>
              <div></div>
              <div className={mainStyle.mainPageButtons}>
                <Button
                  variant="outline-success"
                  onClick={() => handleStatusUpdate("0")}
                  disabled={updateLoading || selectedGroup.length === 0}
                >
                  Active
                </Button>
                <Button
                  variant="outline-danger"
                  disabled={updateLoading || selectedGroup.length === 0}
                  onClick={() => handleStatusUpdate("1")}
                >
                  Deactive
                </Button>
              </div>
            </>
          )}
        </div>

        {showFilter && (
          <div className={mainStyle.mainPageFilter}>
            <div className={mainStyle.mainPageFilterSub}>
              <div className={mainStyle.mainPageFilterDiv}>
                <span>Company</span>
                <Select
                  className={mainStyle.pagesFilter}
                  placeholder="Select Company"
                  options={companyFilter}
                  onChange={handleCompanyFilter}
                  value={companyFilter.find(
                    (option) => option.value === company
                  )}
                />
              </div>
              <div className={mainStyle.mainPageFilterDiv}>
                <span>Status</span>
                <Select
                  className={mainStyle.pagesFilter}
                  placeholder="Action"
                  options={statusOptions}
                  onChange={handleFilterChange}
                  value={statusOptions.find(
                    (option) => option.value === status
                  )}
                />
              </div>
            </div>
          </div>
        )}

        <div
          className={mainStyle.mainContentView}
          style={{ height: showFilter ? "78%" : "92%" }}
        >
          {isLoading ? (
            <PageLoader />
          ) : (
            <div className={mainStyle.mainContentViewsb}>
              {ViewGroupData && ViewGroupData.length > 0 ? (
                <div className={mainStyle.mainTableDiv}>
                  <table className={mainStyle.mainTable}>
                    <thead className={mainStyle.mainTableHead}>
                      <tr>
                        {statusAccess && (
                          <th>
                            <input
                              type="checkbox"
                              checked={isAllChecked}
                              onChange={handleAllCheckboxChange}
                            />
                          </th>
                        )}

                        <th>Group</th>
                        <th>Admin</th>
                        <th>Company</th>

                        <th>Staff</th>
                        <th>Status</th>
                        <th>Created Date</th>
                        {editAccess && <th>##</th>}
                      </tr>
                    </thead>

                    <tbody className={mainStyle.mainTableBody}>
                      {ViewGroupData.map((emp, index) => (
                        <tr key={emp.id || index}>
                          {statusAccess && (
                            <td>
                              <input
                                type="checkbox"
                                checked={selectedGroup.includes(emp.id)}
                                onChange={() => handleCheckboxChange(emp.id)}
                              />
                            </td>
                          )}

                          <td>
                            <div className={mainStyle.tableImgViewdiv}>
                              <div>
                                <div className={mainStyle.tableImgView}>
                                  {emp.group_icon !== null ? (
                                    <img
                                      src={`${apiUrl}${emp.group_icon}`}
                                      alt="img"
                                    />
                                  ) : (
                                    <FallbackAvatar
                                      name={`${emp.group_name}`}
                                      size={40}
                                    />
                                  )}
                                </div>
                              </div>
                              <div className={mainStyle.tableImgViewContent}>
                                <div
                                  className={mainStyle.tableImgViewContentName}
                                >
                                  {`${emp.group_name}`}
                                </div>
                                {/* <div
                                  className={mainStyle.tableImgViewContentEmail}
                                >
                                  {emp.email}
                                </div> */}
                              </div>
                            </div>
                          </td>
                          <td>
                            {emp.get_group_admin_details &&
                              emp.get_group_admin_details.length > 0 && (
                                <div
                                  className={mainStyle.companyLogosContainer}
                                  onClick={() => openAdminListPage(emp)}
                                  style={{ cursor: "pointer" }}
                                >
                                  {emp.get_group_admin_details
                                    .slice(0, 3)
                                    .map((company, i) => {
                                      const hasError =
                                        imageErrorsMG[company.id];
                                      return (
                                        <div
                                          key={i}
                                          className={
                                            mainStyle.companyLogoWrapper
                                          }
                                        >
                                          {!hasError &&
                                          company.emp_pic !== null ? (
                                            <img
                                              src={`${apiUrl}${company.emp_pic}`}
                                              alt={company.first_name}
                                              className={mainStyle.companyLogo}
                                              onError={() =>
                                                setImageErrorsMG((prev) => ({
                                                  ...prev,
                                                  [company.id]: true,
                                                }))
                                              }
                                            />
                                          ) : (
                                            <FallbackAvatar
                                              name={`${company.first_name} ${company.last_name}`}
                                              size={40}
                                            />
                                          )}
                                        </div>
                                      );
                                    })}
                                  {emp.get_group_admin_details.length > 3 && (
                                    <div
                                      className={
                                        mainStyle.moreCompaniesIndicator
                                      }
                                    >
                                      +{emp.get_group_admin_details.length - 3}
                                    </div>
                                  )}
                                </div>
                              )}
                            {/* {emp.get_group_admin_details &&
                              emp.get_group_admin_details.length > 0 && (
                                <div
                                  className={mainStyle.companyLogosContainer}
                                  onClick={() => openAdminListPage(emp)}
                                  style={{ cursor: "pointer" }}
                                >
                                  {emp.get_group_admin_details
                                    .slice(0, 3)
                                    .map((user, i) => (
                                      <img
                                        key={i}
                                        src={`${apiUrl}${user.emp_pic}`}
                                        alt={user.first_name}
                                        className={mainStyle.companyLogo}
                                      />
                                    ))}
                                  {emp.get_group_admin_details.length > 3 && (
                                    <div
                                      className={
                                        mainStyle.moreCompaniesIndicator
                                      }
                                    >
                                      +{emp.get_group_admin_details.length - 3}
                                    </div>
                                  )}
                                </div>
                              )}{" "} */}
                          </td>
                          <td>
                            <div className={mainStyle.tableImgView}>
                              <img
                                src={`${apiUrl}${emp.company_logo}`}
                                alt="img"
                              />
                            </div>
                          </td>

                          <td>
                            {emp.group_users_list &&
                              emp.group_users_list.length > 0 && (
                                <div
                                  className={mainStyle.companyLogosContainer}
                                  onClick={() => openPeopleListPage(emp)}
                                  style={{ cursor: "pointer" }}
                                >
                                  {emp.group_users_list
                                    .slice(0, 3)
                                    .map((company, i) => {
                                      const hasError =
                                        imageErrorsUR[company.id];
                                      return (
                                        <div
                                          key={i}
                                          className={
                                            mainStyle.companyLogoWrapper
                                          }
                                        >
                                          {!hasError &&
                                          company.emp_pic !== null ? (
                                            <img
                                              src={`${apiUrl}${company.emp_pic}`}
                                              alt={company.first_name}
                                              className={mainStyle.companyLogo}
                                              onError={() =>
                                                setImageErrorsUR((prev) => ({
                                                  ...prev,
                                                  [company.id]: true,
                                                }))
                                              }
                                            />
                                          ) : (
                                            <FallbackAvatar
                                              name={`${company.first_name} ${company.last_name}`}
                                              size={40}
                                            />
                                          )}
                                        </div>
                                      );
                                    })}
                                  {emp.group_users_list.length > 3 && (
                                    <div
                                      className={
                                        mainStyle.moreCompaniesIndicator
                                      }
                                    >
                                      +{emp.group_users_list.length - 3}
                                    </div>
                                  )}
                                </div>
                              )}
                            {/* {emp.group_users_list &&
                              emp.group_users_list.length > 0 && (
                                <div
                                  className={mainStyle.companyLogosContainer}
                                  onClick={() =>
                                    openPeopleListPage(
                                      emp,
                                      emp.group_name,
                                      "People List"
                                    )
                                  }
                                  style={{ cursor: "pointer" }}
                                >
                                  {emp.group_users_list
                                    .slice(0, 3)
                                    .map((user, i) => (
                                      <img
                                        key={i}
                                        src={`${apiUrl}${user.emp_pic}`}
                                        alt={user.first_name}
                                        className={mainStyle.companyLogo}
                                      />
                                    ))}
                                  {emp.group_users_list.length > 3 && (
                                    <div
                                      className={
                                        mainStyle.moreCompaniesIndicator
                                      }
                                    >
                                      +{emp.group_users_list.length - 3}
                                    </div>
                                  )}
                                </div>
                              )}{" "} */}
                          </td>
                          <td>
                            <StatusBadge status={emp.group_status} />
                          </td>
                          <td>{formatDate(emp.create_grup_date)}</td>
                          {editAccess && emp.group_status === "0" && (
                            <td>
                              <FiEdit
                                onClick={() => openEditPage(emp.id)}
                                style={{ cursor: "pointer" }}
                              />
                            </td>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <NoDataFound
                  title="No Group Found"
                  description="No Group found. Click the button below to add a new."
                  buttonText="Add Group"
                  onButtonClick={addUserPage}
                />
              )}

              <div>
                {!isLoading && totalGroupCount > perPage && (
                  <PaginationComponent
                    pageCount={Math.ceil(totalGroupCount / perPage)}
                    onPageChange={currentPageNo}
                    forcePage={currentPage - 1}
                  />
                )}
              </div>
            </div>
          )}
        </div>
      </MainLayout>
      {openPeopleList && (
        <GroupPeopleView
          data={datas}
          show={openPeopleList}
          onClose={closePeoplePopup}
        />
      )}
      {showGroupPopup && (
        <ViewGroupPopUp
          onClose={() => setShowGroupPopup(false)}
          groupId={groupId}
          updated={handleUpdated}
        />
      )}
    </>
  );
};

export default ViewGroup;
